import Basis from 'components/basis/Basis';
import SortOrderProvider from 'components/grid/utils/SortOrderContext';
import WrapperEmptyState from 'components/layout/WrapperEmptyState';
import PageWrapper from 'components/utils/PageWrapper';
import BasisConfigurator from 'pages/BasisConfigurator';
import BasisList from 'pages/BasisList';
import BasisSetup from 'pages/BasisSetup';
import basisPlaceholder from '../images/basis-unselected.png';

export const basisListRoutes = {
    path: '/basis',
    element: (
        <PageWrapper titleId="basis_title">
            <BasisList />
        </PageWrapper>
    ),
    children: [
        {
            index: true,
            element: <WrapperEmptyState imgSrc={basisPlaceholder} page="Basis" noun="properties" />,
        },
        {
            path: ':basisId',
            element: (
                <SortOrderProvider>
                    <Basis />
                </SortOrderProvider>
            ),
        },
    ],
};

export const basisConfiguratorRoutes = {
    path: '/basis-configurator/:basisId',
    element: (
        <PageWrapper titleId="basis_configurator_title">
            <BasisConfigurator />
        </PageWrapper>
    ),
};

export const basisSetupRoutes = {
    path: '/basis-configurator',
    element: (
        <PageWrapper titleId="basis_configurator_title">
            <BasisSetup />
        </PageWrapper>
    ),
};
